export const CommodityCategory = {
	other: 0,
	salmon: 1,
	whitefish: 2,
	dryfish: 3,
};
